var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"corporateTraining"},[_c('app-CorporateTrainingHero'),_c('app-AboutTraining'),_c('app-TrainingBenefits'),_c('app-ContactUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }